import React from 'react';
import QuickViewSearch from 'components/QuickViewSearch';
import { ITranslations } from 'components/QuickViewSearch/shared/types';
import { useTranslation } from 'react-i18next';
import * as transKey from 'autogen/translation-keys/trans-root-website';
import { FindStoreResult, ProductInfoModel, ProductStoreStockViewModel } from 'autogen/swagger/all';
import StoreList from './components/storeList';

interface IQuickViewContent {
    findStoreResult?: FindStoreResult;
    initialPreferredStore?: ProductStoreStockViewModel['initialPreferredStore'];
    showSelectParcelShop?: boolean;
    productInfo?: ProductInfoModel;
}

export default function StoreListQuickView({
    findStoreResult,
    initialPreferredStore,
    showSelectParcelShop,
    productInfo
}: IQuickViewContent) {
    const searchQuery = findStoreResult?.searchData.addressQuery || undefined;
    const { t } = useTranslation();
    const {
        Headline,
        SubHeadline,
        SubHeadlineAfterSearch,
        SubHeadlineNoResult,
        GeoLocationErrorText,
        SearchFieldLabel,
        SearchFieldPlaceholder,
        ShowSearchButton,
        SubmitButtonText,
        SummaryCaption,
        UseGeoLocationButton,
        ChooseStoreButtonText
    } = transKey.ProductStoreSearch;
    const subHeadline = (): string => {
        if (searchQuery && !findStoreResult?.parcelShops?.length) {
            return t(SubHeadlineNoResult);
        }

        if (searchQuery && findStoreResult) {
            return t(SubHeadlineAfterSearch);
        }

        return t(SubHeadline);
    };

    const translations: ITranslations = {
        headline: t(Headline),
        subHeadline: subHeadline(),
        search: {
            placeholder: t(SearchFieldPlaceholder),
            searchResultText: t(SummaryCaption),
            submitButtonText: t(SubmitButtonText),
            textFieldTitle: t(SearchFieldLabel),
            showSearch: t(ShowSearchButton),
            geoLocation: {
                button: t(UseGeoLocationButton),
                errorText: t(GeoLocationErrorText)
            }
        }
    };

    return (
        <QuickViewSearch
            translations={translations}
            inputType="text"
            searchQuery={searchQuery}
            trackingCategory="storeStockCheckerQuickView"
            productInfo={productInfo}
        >
            {findStoreResult && (
                <StoreList
                    {...findStoreResult}
                    translations={{ chooseStoreButtonText: t(ChooseStoreButtonText) }}
                    initialPreferredStore={initialPreferredStore}
                    trackingCategory="storeStockCheckerQuickView"
                    showSelectParcelShop={showSelectParcelShop}
                />
            )}
        </QuickViewSearch>
    );
}
